import { Tag } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export const VERIFICATION_STATUS = {
  pending: "pending",
  verified: "verified",
  failed: "failed"
}

const TAG_COLOR = {
  [VERIFICATION_STATUS.pending]: "warning",
  [VERIFICATION_STATUS.verified]: "success",
  [VERIFICATION_STATUS.failed]: "error"
}

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation()

  if (!status || !TAG_COLOR[status]) return null

  return (
    <Tag color={TAG_COLOR[status]}>
      {t(`customEmail.status.${status}`)}
    </Tag>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(VERIFICATION_STATUS))
}
